import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=03cfd66c&scoped=true&"
import script from "./Documentos.vue?vue&type=script&lang=js&"
export * from "./Documentos.vue?vue&type=script&lang=js&"
import style0 from "./Documentos.vue?vue&type=style&index=0&id=03cfd66c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cfd66c",
  null
  
)

export default component.exports